module.exports = __webpack_public_path__ + "static/media/trainingSteps.5453622d.jpg";